// Pretty-print JSON in a monospace block. Collapsed by default;
// click the header to expand. Used for tenant.vault_sync_payload
// and audit before_state / after_state.

import { useState } from "react";

interface JSONViewerProps {
  value: unknown;
  title?: string;
  initiallyOpen?: boolean;
  emptyLabel?: string;
}

export function JSONViewer({
  value,
  title = "JSON",
  initiallyOpen = false,
  emptyLabel = "(empty)",
}: JSONViewerProps) {
  const [open, setOpen] = useState(initiallyOpen);
  const isEmpty =
    value == null ||
    (typeof value === "object" && Object.keys(value as object).length === 0);
  return (
    <div
      style={{
        border: "1px solid var(--border)",
        borderRadius: 6,
        background: "var(--surface-2)",
        fontSize: "0.78rem",
      }}
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          width: "100%",
          padding: "6px 10px",
          background: "transparent",
          border: "none",
          color: "var(--text-dim)",
          cursor: "pointer",
          fontSize: "0.78rem",
          fontFamily: "inherit",
          textAlign: "left",
        }}
      >
        <span style={{ width: 10, display: "inline-block" }}>{open ? "▾" : "▸"}</span>
        <span>{title}</span>
        {isEmpty && <span style={{ marginLeft: 6 }}>{emptyLabel}</span>}
      </button>
      {open && !isEmpty && (
        <pre
          style={{
            margin: 0,
            padding: "8px 10px",
            borderTop: "1px solid var(--border)",
            overflowX: "auto",
            fontFamily:
              'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
            fontSize: "0.78rem",
            color: "var(--text)",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {JSON.stringify(value, null, 2)}
        </pre>
      )}
    </div>
  );
}
